export default __webpack_public_path__ + "static/media/LogoBurnCube.026ada12.png";